import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { ToggleProvider } from "@/contexts/ToggleContext";
import { SiteSettingsProvider } from "@/contexts/SiteSettingsContext";
import { AdminAuthProvider } from "@/contexts/AdminAuthContext";
import { CustomerAuthProvider } from "@/contexts/CustomerAuthContext";

import Home from "@/pages/Home";
import CategoryPage from "@/pages/CategoryPage";
import ProductDetail from "@/pages/ProductDetail";
import SearchPage from "@/pages/SearchPage";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import AuthCallback from "@/pages/AuthCallback";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import Wishlist from "@/pages/Wishlist";
import Orders from "@/pages/Orders";
import OrderDetail from "@/pages/OrderDetail";
import PolicyPage from "@/pages/PolicyPage";
import ContactPage from "@/pages/ContactPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminLayout from "@/pages/AdminLayout";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminProducts from "@/pages/AdminProducts";
import AdminCategories from "@/pages/AdminCategories";
import AdminSiteSettings from "@/pages/AdminSiteSettings";
import AdminToggles from "@/pages/AdminToggles";
import AdminChatbotQA from "@/pages/AdminChatbotQA";
import AdminWhitelist from "@/pages/AdminWhitelist";
import AdminOrders from "@/pages/AdminOrders";
import AdminLeads from "@/pages/AdminLeads";
import AdminCoupons from "@/pages/AdminCoupons";
import AdminReviews from "@/pages/AdminReviews";
import AdminNewsletter from "@/pages/AdminNewsletter";
import AdminTestimonials from "@/pages/AdminTestimonials";
import AdminInstagram from "@/pages/AdminInstagram";
import AdminPolicyPages from "@/pages/AdminPolicyPages";
import AdminContactMessages from "@/pages/AdminContactMessages";
import AdminCustomers from "@/pages/AdminCustomers";
import AdminLoyaltySettings from "@/pages/AdminLoyaltySettings";
import AdminCodSettings from "@/pages/AdminCodSettings";
import AdminCodForfeits from "@/pages/AdminCodForfeits";
import AccountLoyalty from "@/pages/AccountLoyalty";
import NotFound from "@/pages/NotFound";
import { AdminProtectedRoute } from "@/components/AdminProtectedRoute";
import { CustomerProtectedRoute } from "@/components/CustomerProtectedRoute";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AdminAuthProvider>
                    <CustomerAuthProvider>
                        <SiteSettingsProvider>
                            <ToggleProvider>
                                <Routes>
                                    <Route path="/" element={<Home />} />
                                    <Route path="/category/:slug" element={<CategoryPage />} />
                                    <Route path="/product/:slug" element={<ProductDetail />} />
                                    <Route path="/search" element={<SearchPage />} />
                                    <Route path="/policy/:slug" element={<PolicyPage />} />
                                    <Route path="/loyalty" element={<Navigate to="/policy/loyalty" replace />} />
                                    <Route path="/contact" element={<ContactPage />} />

                                    <Route path="/login" element={<Login />} />
                                    <Route path="/signup" element={<Signup />} />
                                    <Route path="/auth/callback" element={<AuthCallback />} />

                                    <Route path="/cart" element={<Cart />} />
                                    <Route path="/wishlist" element={<Wishlist />} />
                                    <Route path="/checkout" element={<CustomerProtectedRoute><Checkout /></CustomerProtectedRoute>} />
                                    <Route path="/orders" element={<CustomerProtectedRoute><Orders /></CustomerProtectedRoute>} />
                                    <Route path="/orders/:id" element={<CustomerProtectedRoute><OrderDetail /></CustomerProtectedRoute>} />
                                    <Route path="/account/loyalty" element={<CustomerProtectedRoute><AccountLoyalty /></CustomerProtectedRoute>} />

                                    <Route path="/admin/login" element={<AdminLogin />} />
                                    <Route
                                        path="/admin"
                                        element={
                                            <AdminProtectedRoute>
                                                <AdminLayout />
                                            </AdminProtectedRoute>
                                        }
                                    >
                                        <Route index element={<AdminDashboard />} />
                                        <Route path="products" element={<AdminProducts />} />
                                        <Route path="categories" element={<AdminCategories />} />
                                        <Route path="coupons" element={<AdminCoupons />} />
                                        <Route path="orders" element={<AdminOrders />} />
                                        <Route path="leads" element={<AdminLeads />} />
                                        <Route path="reviews" element={<AdminReviews />} />
                                        <Route path="newsletter" element={<AdminNewsletter />} />
                                        <Route path="testimonials" element={<AdminTestimonials />} />
                                        <Route path="instagram" element={<AdminInstagram />} />
                                        <Route path="policy-pages" element={<AdminPolicyPages />} />
                                        <Route path="contact-messages" element={<AdminContactMessages />} />
                                        <Route path="customers" element={<AdminCustomers />} />
                                        <Route path="loyalty-settings" element={<AdminLoyaltySettings />} />
                                        <Route path="cod-settings" element={<AdminCodSettings />} />
                                        <Route path="cod-forfeits" element={<AdminCodForfeits />} />
                                        <Route path="chatbot" element={<AdminChatbotQA />} />
                                        <Route path="site-settings" element={<AdminSiteSettings />} />
                                        <Route path="toggles" element={<AdminToggles />} />
                                        <Route path="whitelist" element={<AdminWhitelist />} />
                                    </Route>

                                    <Route path="*" element={<NotFound />} />
                                </Routes>
                                <Toaster position="bottom-right" richColors closeButton />
                            </ToggleProvider>
                        </SiteSettingsProvider>
                    </CustomerAuthProvider>
                </AdminAuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
